import React, { useContext, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { SettingsContext } from "../../../contexts";
import { Visible } from "../../../core/components";
import { Select } from "../../../components";

const actionLabel = (action) => {
  switch (action) {
    case "edit":
      return "Edit";
    case "edit_px":
      return "Edit Part Exchange";
    default:
      return "Action";
  }
};

const getOptions = (item) => [
  {
    label: "Actions",
    options: [
      { id: "edit", name: "Edit" },
      ...(item.px_request_id
        ? [{ id: "edit_px", name: "Edit Part Exchange" }]
        : []),
    ],
  },
];

const ClientActions = ({ item }) => {
  const settings = useContext(SettingsContext);
  const history = useHistory();
  const { owner } = useParams();
  const [action, setAction] = useState(null);
  const options = useMemo(() => getOptions(item), [item]);

  const updateItem = async () => {
    switch (action) {
      case "edit":
        return history.push(
          `/request/${item.request_type}/${item?.id}?bb=${owner}&${settings.iframeQueryParams}`
        );
      case "edit_px":
        return history.push(
          `/request/${item.px_request_type}/${item.px_request_id}?bb=${owner}&${settings.iframeQueryParams}`
        );
      case "retrieve":
        return await axios.put(`/api/requests/${item.id}/admin`, {
          status: "new",
          hidden: false,
        });
    }
  };

  if (item.hidden) {
    return (
      <div className={`manage-request-item action-button d-flex`}>
        <div
          className={`main ${action ? "action-selected d-flex" : ""}`}
          style={{ width: "150px" }}
        >
          <Select
            {...{
              className: `order-action-selector ${action ? "loaded" : ""}`,
              placeholder: "Action",
              options: [{ id: "retrieve", name: "Retrieve" }],
              onSelectionChange: (a) => setAction(a),
              field: { name: "action_selector", value: action },
              form: { setFieldValue: () => {} },
              isSearchable: false,
            }}
          />
        </div>
        <Visible when={!!action}>
          <div className={`do-action`} onClick={() => updateItem()}>
            <Visible>
              <img src="/assets/icons/next-2.svg"></img>
            </Visible>
          </div>
        </Visible>
      </div>
    );
  }

  const goToRequest = () => {
    const url = `/request/${item.px_request_type ||
      item.request_type}/${item?.px_request_id || item?.id}?${
      settings.iframeQueryParams
    }`;
    window.open(url, '_blank');
  };

  return (
    <button className="mt-2 mt-md-0 " onClick={() => goToRequest()}>
      View
    </button>
  );
};

export default ClientActions;
